import React from 'react';

import { RequestExceptionWithResponse } from '@eika-infrastruktur/request';
import { Button } from '@eika/button';

import { useRefreshEfaktura } from '../../fetchHooks/useEfaktura';
import useTranslation from '../../hooks/useTranslation';
import { ErrorCardWrapper } from '../shared/ErrorCardWrapper';

import './EFakturaList.scss';

interface Props {
    error: RequestExceptionWithResponse;
}

const EFakturaListError: React.FC<Props> = ({ error }) => {
    const translated = useTranslation();

    const refreshEfaktura = useRefreshEfaktura();
    const refreshEfakturas = () => {
        refreshEfaktura();
    };

    return (
        <ErrorCardWrapper title="" exception={error} className="eFaktura-list__error-card">
            <Button size="small" onClick={refreshEfakturas}>
                {translated.tryAgain}
            </Button>
        </ErrorCardWrapper>
    );
};

export default EFakturaListError;
